// web/src/content/data_safety.ts — Plain-English data safety FAQ content.
// PLACEHOLDER COPY — confirm with engineering + legal before public launch.
export const DATA_SAFETY_QAS = [
    {
        q: "What does Matchrail store about me?",
        a: "Your profile (demographics, accounts, holdings, goals) and the conversations you have with Luna. Account balances and holdings are stored as you entered them — Matchrail does not pull them from banks or brokerages unless you explicitly connect those institutions via a supported integration.",
    },
    {
        q: "Who can access my data?",
        a: "Only you, and a small number of Matchrail engineers who may need access for support, security, or debugging. Access by engineers is logged. We do not sell your data, and we do not share it with brokerages, advisers, or marketers.",
    },
    {
        q: "Is my data used to train AI models?",
        a: "No. Your inputs and conversation history are not used to train any AI model — neither ours nor any third-party provider's. Where we use third-party LLM providers, we use API endpoints that contractually prohibit training on customer data.",
    },
    {
        q: "How is my data secured at rest?",
        a: "Sensitive fields (auth secrets, tokens) are encrypted at rest using industry-standard AES-256. Database storage is encrypted at the volume level. Traffic between your browser and Matchrail is TLS-encrypted end to end.",
    },
    {
        q: "Can I delete my data?",
        a: "Yes. You can delete your account from the Profile page at any time. Account deletion cascades to all associated data (profile, conversations, memory, audit logs) within 30 days, except where retention is required by law (e.g. financial transaction records, if any).",
    },
    {
        q: "What about demo accounts?",
        a: "Demo accounts use illustrative profiles with hypothetical numbers. Those profiles are loaded from publicly-shipped fixture files — they contain no real personal data. You can delete a demo account exactly like a real one.",
    },
    {
        q: "Where is my data located?",
        a: "All data is stored in cloud infrastructure located in the United States.",
    },
];
